import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { Props } from '@/types';
import { CardsBlockCss } from '../../../styles';
import { useSearch } from '../buscarFiltrar/SearchContext';
import Loader from '../loaderAndError/Loader';
import { buildImageUrl } from '@/api/buildImageUrl';

const SeccionCard: React.FC<Props> = ({ seccion }) => {
  const { registerItem, unregisterItem } = useSearch();
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!seccion) return;
    const itemId = `seccion-${seccion.id ?? seccion.nombreSeccion}`;
    registerItem({
      id: itemId,
      title: seccion.nombreSeccion,
      content: seccion.descripcion ?? "",
      type: "seccion",
      tags: [
        seccion.nombre_profesion,
        seccion.nombre_empresa,
        seccion.nombreSeccion,
      ].filter(Boolean),
    });

    return () => unregisterItem(itemId);
  }, []);

  
  return (
    <div className={`${CardsBlockCss.profesion} flex rounded-2xl overflow-hidden min-h-48 relative`}>
      <Link
        to={`/profesiones/${seccion.nombreSeccion}`}
        className="relative block w-full h-full"
      >
        {/* Loader */}
        {!imageLoaded && (
          <div className="absolute inset-0 flex justify-center items-center bg-gray-200 z-10">
            <Loader />
          </div>
        )}

        {/* Imagen */}
        <img
          src={buildImageUrl(seccion.foto_perfil)}
          alt={seccion.nombreSeccion}
          className={`transition-all duration-300 ease-in-out w-full h-full object-cover ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoad={() => setImageLoaded(true)}
        />

        {/* Nombre */}
        <div className={`${CardsBlockCss.nombreProfesion} p-2`}>
          <h2 className="text-sm md:text-[18px] font-semibold text-center">
            {seccion.nombreSeccion}
          </h2>
        </div>

        {/* Descripción */}
        <div className={`${CardsBlockCss.descripcionProfesion} p-4 custom-scrollbar`}>
          <p
            className="text-sm text-start leading-relaxed"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                (seccion.descripcion ?? "").replace(/(\n|\r)/g, "<br/>")
              ),
            }}
          />
        </div>
      </Link>
    </div>
  );
};

export default SeccionCard;
